import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.3.5_@babel+core@7.29.7_@opentelemetry+api@1.9.0_@playwright+test@1.60.0_@types+_da6ed00fbbc4d7f8b7339b3be7582ffc/node_modules/next/dist/client/app-dir/link.js");
